import React from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { MAPS_KEY } from 'src/config';

export const MapComponent = ({ latitude, longitude, width = '100%', height = '400px' }) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: MAPS_KEY,
  });

  const center = {
    lat: latitude,
    lng: longitude,
  };

  const onLoad = React.useCallback((map) => {
    map.setCenter(center);
    map.setZoom(13); // Ensure zoom level is consistently set
  }, [center]);

  const onUnmount = React.useCallback(() => {}, []);

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={{ width, height, border: '0px' }}
      center={center}
      zoom={13} // Set desired zoom level
      onLoad={onLoad}
      onUnmount={onUnmount}
    >
      <Marker position={center} />
    </GoogleMap>
  ) : null;
};

export default React.memo(MapComponent);
